<main>
  <div #mainContent></div>
  <ng-template #dynamicLayoutCmp></ng-template>
</main>
